import {Copy} from 'lucide-react';
import {GmailStatus} from '../../types';
import {Btn} from '../Shared';
import {toast} from '../ui/sonner';

async function copyRedirect(uri: string): Promise<void> {
  try { await navigator.clipboard.writeText(uri); toast.success('Redirect URI copied'); }
  catch { toast.error('Please copy the URI manually.'); }
}

export const GmailSetup = ({gmail}: {gmail: GmailStatus | null}) => <details className="setup-section" open={!gmail?.connected} data-testid="gmail-setup-details">
  <summary data-testid="gmail-setup-toggle">Google connection setup</summary>
  <div className="setup-content"><p data-testid="gmail-setup-status">Google credentials are configured. Before connecting, check these settings in your Google Cloud project:</p>
    <ol style={{paddingLeft: 18, marginTop: 10, listStyle: 'decimal'}}><li>Enable the Gmail API.</li><li>Add your Gmail address as an OAuth test user if the app is in testing.</li><li>Add this exact authorized redirect URI to your Web application OAuth client:</li></ol>
    <code data-testid="gmail-redirect-uri">{gmail?.redirect_uri}</code>
    <div className="connection-actions"><Btn data-testid="gmail-copy-redirect" disabled={!gmail?.redirect_uri} onClick={() => copyRedirect(gmail?.redirect_uri ?? '')}><Copy size={12}/>Copy URI</Btn>
      <a href="https://console.cloud.google.com/apis/credentials" target="_blank" rel="noreferrer" data-testid="google-cloud-link">Google Cloud Console ↗</a>
    </div>
  </div>
</details>;